// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { BulkDeleteImagesApiAdminImagesBulkDeleteData, BulkDeleteImagesApiAdminImagesBulkDeleteErrors, BulkDeleteImagesApiAdminImagesBulkDeleteResponses, BulkUpdateCategoriesApiAdminImagesBulkCategoriesPatchData, BulkUpdateCategoriesApiAdminImagesBulkCategoriesPatchErrors, BulkUpdateCategoriesApiAdminImagesBulkCategoriesPatchResponses, BulkUpdateVisibilityApiAdminImagesBulkVisibilityPatchData, BulkUpdateVisibilityApiAdminImagesBulkVisibilityPatchErrors, BulkUpdateVisibilityApiAdminImagesBulkVisibilityPatchResponses, CreateAlbumApiAdminAlbumsPostData, CreateAlbumApiAdminAlbumsPostErrors, CreateAlbumApiAdminAlbumsPostResponses, CreateCategoryApiCategoriesPostData, CreateCategoryApiCategoriesPostErrors, CreateCategoryApiCategoriesPostResponses, CreateSettingApiSiteSettingsPostData, CreateSettingApiSiteSettingsPostErrors, CreateSettingApiSiteSettingsPostResponses, CreateSubcategoryApiCategoriesSubcategoriesPostData, CreateSubcategoryApiCategoriesSubcategoriesPostErrors, CreateSubcategoryApiCategoriesSubcategoriesPostResponses, DeleteAdminImageApiAdminImagesImageIdDeleteData, DeleteAdminImageApiAdminImagesImageIdDeleteErrors, DeleteAdminImageApiAdminImagesImageIdDeleteResponses, DeleteAlbumApiAdminAlbumsAlbumIdDeleteData, DeleteAlbumApiAdminAlbumsAlbumIdDeleteErrors, DeleteAlbumApiAdminAlbumsAlbumIdDeleteResponses, DeleteCategoryApiCategoriesCategoryIdDeleteData, DeleteCategoryApiCategoriesCategoryIdDeleteErrors, DeleteCategoryApiCategoriesCategoryIdDeleteResponses, DeleteSettingApiSiteSettingsKeyDeleteData, DeleteSettingApiSiteSettingsKeyDeleteErrors, DeleteSettingApiSiteSettingsKeyDeleteResponses, DeleteSubcategoryApiCategoriesSubcategoriesSubcategoryIdDeleteData, DeleteSubcategoryApiCategoriesSubcategoriesSubcategoryIdDeleteErrors, DeleteSubcategoryApiCategoriesSubcategoriesSubcategoryIdDeleteResponses, GetAdminImageApiAdminImagesImageIdGetData, GetAdminImageApiAdminImagesImageIdGetErrors, GetAdminImageApiAdminImagesImageIdGetResponses, GetAdminImageInfoApiAdminImagesPublicIdInfoGetData, GetAdminImageInfoApiAdminImagesPublicIdInfoGetErrors, GetAdminImageInfoApiAdminImagesPublicIdInfoGetResponses, GetAdminStatisticsApiAdminImagesStatisticsGetData, GetAdminStatisticsApiAdminImagesStatisticsGetResponses, GetAlbumApiAdminAlbumsAlbumIdGetData, GetAlbumApiAdminAlbumsAlbumIdGetErrors, GetAlbumApiAdminAlbumsAlbumIdGetResponses, GetAlbumImagesApiAdminAlbumsAlbumIdImagesGetData, GetAlbumImagesApiAdminAlbumsAlbumIdImagesGetErrors, GetAlbumImagesApiAdminAlbumsAlbumIdImagesGetResponses, GetCategoryApiCategoriesCategoryIdGetData, GetCategoryApiCategoriesCategoryIdGetErrors, GetCategoryApiCategoriesCategoryIdGetResponses, GetCurrentUserInfoApiAuthMeGetData, GetCurrentUserInfoApiAuthMeGetResponses, GetFeaturedPublicAlbumsApiPublicAlbumsFeaturedGetData, GetFeaturedPublicAlbumsApiPublicAlbumsFeaturedGetErrors, GetFeaturedPublicAlbumsApiPublicAlbumsFeaturedGetResponses, GetFeaturedPublicImagesApiPublicGalleryFeaturedGetData, GetFeaturedPublicImagesApiPublicGalleryFeaturedGetErrors, GetFeaturedPublicImagesApiPublicGalleryFeaturedGetResponses, GetImageSitemapSitemapImagesXmlGetData, GetImageSitemapSitemapImagesXmlGetResponses, GetPublicAlbumApiPublicAlbumsAlbumIdGetData, GetPublicAlbumApiPublicAlbumsAlbumIdGetErrors, GetPublicAlbumApiPublicAlbumsAlbumIdGetResponses, GetPublicAlbumImagesApiPublicAlbumsAlbumIdImagesGetData, GetPublicAlbumImagesApiPublicAlbumsAlbumIdImagesGetErrors, GetPublicAlbumImagesApiPublicAlbumsAlbumIdImagesGetResponses, GetPublicAlbumsApiPublicAlbumsGetData, GetPublicAlbumsApiPublicAlbumsGetErrors, GetPublicAlbumsApiPublicAlbumsGetResponses, GetPublicCategoriesApiPublicGalleryCategoriesGetData, GetPublicCategoriesApiPublicGalleryCategoriesGetResponses, GetPublicGalleryApiPublicGalleryGetData, GetPublicGalleryApiPublicGalleryGetErrors, GetPublicGalleryApiPublicGalleryGetResponses, GetPublicSettingsApiSiteSettingsPublicGetData, GetPublicSettingsApiSiteSettingsPublicGetResponses, GetPublicTagsApiPublicGalleryTagsGetData, GetPublicTagsApiPublicGalleryTagsGetResponses, GetSettingApiSiteSettingsKeyGetData, GetSettingApiSiteSettingsKeyGetErrors, GetSettingApiSiteSettingsKeyGetResponses, GetSitemapSitemapXmlGetData, GetSitemapSitemapXmlGetResponses, GetSubcategoryApiCategoriesSubcategoriesSubcategoryIdGetData, GetSubcategoryApiCategoriesSubcategoriesSubcategoryIdGetErrors, GetSubcategoryApiCategoriesSubcategoriesSubcategoryIdGetResponses, GetTestimonialsApiPublicTestimonialsGetData, GetTestimonialsApiPublicTestimonialsGetResponses, GetUnviewedSubmissionsCountApiAdminContactSubmissionsUnviewedCountGetData, GetUnviewedSubmissionsCountApiAdminContactSubmissionsUnviewedCountGetResponses, HealthCheckHealthGetData, HealthCheckHealthGetResponses, ListAdminImagesApiAdminImagesGetData, ListAdminImagesApiAdminImagesGetErrors, ListAdminImagesApiAdminImagesGetResponses, ListAlbumsApiAdminAlbumsGetData, ListAlbumsApiAdminAlbumsGetErrors, ListAlbumsApiAdminAlbumsGetResponses, ListCategoriesApiCategoriesGetData, ListCategoriesApiCategoriesGetErrors, ListCategoriesApiCategoriesGetResponses, ListCloudinaryImagesApiAdminImagesCloudinaryGetData, ListCloudinaryImagesApiAdminImagesCloudinaryGetErrors, ListCloudinaryImagesApiAdminImagesCloudinaryGetResponses, ListContactSubmissionsAdminApiAdminContactSubmissionsGetData, ListContactSubmissionsAdminApiAdminContactSubmissionsGetResponses, ListSettingsApiSiteSettingsGetData, ListSettingsApiSiteSettingsGetResponses, ListSubcategoriesApiCategoriesSubcategoriesGetData, ListSubcategoriesApiCategoriesSubcategoriesGetErrors, ListSubcategoriesApiCategoriesSubcategoriesGetResponses, LoginApiAuthLoginPostData, LoginApiAuthLoginPostErrors, LoginApiAuthLoginPostResponses, LogoutApiAuthLogoutPostData, LogoutApiAuthLogoutPostResponses, MarkContactSubmissionUnviewedApiAdminContactSubmissionsSubmissionIdUnviewedPatchData, MarkContactSubmissionUnviewedApiAdminContactSubmissionsSubmissionIdUnviewedPatchErrors, MarkContactSubmissionUnviewedApiAdminContactSubmissionsSubmissionIdUnviewedPatchResponses, MarkContactSubmissionViewedApiAdminContactSubmissionsSubmissionIdViewedPatchData, MarkContactSubmissionViewedApiAdminContactSubmissionsSubmissionIdViewedPatchErrors, MarkContactSubmissionViewedApiAdminContactSubmissionsSubmissionIdViewedPatchResponses, RecordAlbumViewApiPublicAlbumsAlbumIdViewPostData, RecordAlbumViewApiPublicAlbumsAlbumIdViewPostErrors, RecordAlbumViewApiPublicAlbumsAlbumIdViewPostResponses, RecordImageViewApiPublicImagesImageIdViewPostData, RecordImageViewApiPublicImagesImageIdViewPostErrors, RecordImageViewApiPublicImagesImageIdViewPostResponses, RefreshTokenApiAuthRefreshPostData, RefreshTokenApiAuthRefreshPostErrors, RefreshTokenApiAuthRefreshPostResponses, RootGetData, RootGetResponses, RunMigrationsMigratePostData, RunMigrationsMigratePostResponses, RunSeedSeedPostData, RunSeedSeedPostErrors, RunSeedSeedPostResponses, SubmitContactFormApiPublicContactPostData, SubmitContactFormApiPublicContactPostErrors, SubmitContactFormApiPublicContactPostResponses, SyncCloudinaryWithDatabaseApiAdminImagesSyncCloudinaryPostData, SyncCloudinaryWithDatabaseApiAdminImagesSyncCloudinaryPostErrors, SyncCloudinaryWithDatabaseApiAdminImagesSyncCloudinaryPostResponses, ToggleAdminImageVisibilityApiAdminImagesImageIdVisibilityPatchData, ToggleAdminImageVisibilityApiAdminImagesImageIdVisibilityPatchErrors, ToggleAdminImageVisibilityApiAdminImagesImageIdVisibilityPatchResponses, UpdateAdminImageApiAdminImagesImageIdPatchData, UpdateAdminImageApiAdminImagesImageIdPatchErrors, UpdateAdminImageApiAdminImagesImageIdPatchResponses, UpdateAlbumApiAdminAlbumsAlbumIdPatchData, UpdateAlbumApiAdminAlbumsAlbumIdPatchErrors, UpdateAlbumApiAdminAlbumsAlbumIdPatchResponses, UpdateCategoryApiCategoriesCategoryIdPatchData, UpdateCategoryApiCategoriesCategoryIdPatchErrors, UpdateCategoryApiCategoriesCategoryIdPatchResponses, UpdateSettingApiSiteSettingsKeyPutData, UpdateSettingApiSiteSettingsKeyPutErrors, UpdateSettingApiSiteSettingsKeyPutResponses, UpdateSubcategoryApiCategoriesSubcategoriesSubcategoryIdPatchData, UpdateSubcategoryApiCategoriesSubcategoriesSubcategoryIdPatchErrors, UpdateSubcategoryApiCategoriesSubcategoriesSubcategoryIdPatchResponses, UploadAdminImageApiAdminImagesUploadPostData, UploadAdminImageApiAdminImagesUploadPostErrors, UploadAdminImageApiAdminImagesUploadPostResponses, UploadMultipleAdminImagesApiAdminImagesUploadMultiplePostData, UploadMultipleAdminImagesApiAdminImagesUploadMultiplePostErrors, UploadMultipleAdminImagesApiAdminImagesUploadMultiplePostResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Root
 *
 * Health check endpoint.
 */
export const rootGet = <ThrowOnError extends boolean = false>(options?: Options<RootGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<RootGetResponses, unknown, ThrowOnError>({
        url: '/',
        ...options
    });
};

/**
 * Health Check
 *
 * Detailed health check endpoint.
 */
export const healthCheckHealthGet = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckHealthGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<HealthCheckHealthGetResponses, unknown, ThrowOnError>({
        url: '/health',
        ...options
    });
};

/**
 * Run Migrations
 *
 * Run database migrations.
 */
export const runMigrationsMigratePost = <ThrowOnError extends boolean = false>(options?: Options<RunMigrationsMigratePostData, ThrowOnError>) => {
    return (options?.client ?? client).post<RunMigrationsMigratePostResponses, unknown, ThrowOnError>({
        url: '/migrate',
        ...options
    });
};

/**
 * Run Seed
 *
 * Run database seed script to create admin user and initial data.
 *
 * Args:
 * force_update_admin: If True, delete and recreate the admin user (useful for password reset)
 */
export const runSeedSeedPost = <ThrowOnError extends boolean = false>(options?: Options<RunSeedSeedPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<RunSeedSeedPostResponses, RunSeedSeedPostErrors, ThrowOnError>({
        url: '/seed',
        ...options
    });
};

/**
 * Login
 *
 * Login endpoint - authenticate user and return JWT tokens.
 *
 * Rate limited to 5 attempts per minute per IP to prevent brute force attacks.
 *
 * Args:
 * request: Request object (for rate limiting)
 * login_data: Email and password
 * db: Database session
 *
 * Returns:
 * Access token, refresh token, and user information
 *
 * Raises:
 * HTTPException: If credentials are invalid
 * RateLimitExceeded: If too many login attempts
 */
export const loginApiAuthLoginPost = <ThrowOnError extends boolean = false>(options: Options<LoginApiAuthLoginPostData, ThrowOnError>) => {
    return (options.client ?? client).post<LoginApiAuthLoginPostResponses, LoginApiAuthLoginPostErrors, ThrowOnError>({
        url: '/api/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Refresh Token
 *
 * Refresh token endpoint - get new access token using refresh token.
 *
 * Args:
 * request: Request object (for IP address)
 * refresh_data: Refresh token
 * db: Database session
 *
 * Returns:
 * New access token, new refresh token, and user information
 *
 * Raises:
 * HTTPException: If refresh token is invalid
 */
export const refreshTokenApiAuthRefreshPost = <ThrowOnError extends boolean = false>(options: Options<RefreshTokenApiAuthRefreshPostData, ThrowOnError>) => {
    return (options.client ?? client).post<RefreshTokenApiAuthRefreshPostResponses, RefreshTokenApiAuthRefreshPostErrors, ThrowOnError>({
        url: '/api/auth/refresh',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Current User Info
 *
 * Get current authenticated user information.
 *
 * Args:
 * current_user: Current authenticated user from token
 *
 * Returns:
 * User information
 */
export const getCurrentUserInfoApiAuthMeGet = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserInfoApiAuthMeGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetCurrentUserInfoApiAuthMeGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/auth/me',
        ...options
    });
};

/**
 * Logout
 *
 * Logout endpoint - revoke current access token by adding to blacklist.
 *
 * The token is immediately invalidated and cannot be used for future requests.
 * Clients should also delete tokens from local storage.
 *
 * Args:
 * request: Request object (for IP address)
 * credentials: HTTP Bearer token credentials
 * current_user: Current authenticated user from token
 * db: Database session
 *
 * Returns:
 * Success message
 */
export const logoutApiAuthLogoutPost = <ThrowOnError extends boolean = false>(options?: Options<LogoutApiAuthLogoutPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<LogoutApiAuthLogoutPostResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/auth/logout',
        ...options
    });
};

/**
 * List Admin Images
 *
 * List images with admin-specific filtering and pagination.
 *
 * This endpoint provides admin-specific features like viewing private images,
 * advanced date filtering, and admin-only sorting options.
 *
 * Args:
 * page: Page number (1-indexed)
 * page_size: Items per page (max 100)
 * is_public: Filter by public/private status (admin can see both)
 * category_id: Filter by category
 * subcategory_id: Filter by subcategory
 * search: Search in title, description, alt_text
 * date_from: Filter by upload date (YYYY-MM-DD)
 * date_to: Filter by upload date (YYYY-MM-DD)
 * sort_by: Sort field (admin can sort by more fields)
 * sort_order: Sort direction (asc, desc)
 * db: Database session
 * current_user: Current authenticated user
 *
 * Returns:
 * Paginated list of images
 */
export const listAdminImagesApiAdminImagesGet = <ThrowOnError extends boolean = false>(options?: Options<ListAdminImagesApiAdminImagesGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListAdminImagesApiAdminImagesGetResponses, ListAdminImagesApiAdminImagesGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/images',
        ...options
    });
};

/**
 * Bulk Update Visibility
 *
 * Bulk update visibility for multiple images (admin only).
 *
 * Args:
 * image_ids: List of image IDs to update
 * is_public: New visibility status
 * db: Database session
 * current_user: Current authenticated user
 *
 * Returns:
 * Bulk update result
 */
export const bulkUpdateVisibilityApiAdminImagesBulkVisibilityPatch = <ThrowOnError extends boolean = false>(options: Options<BulkUpdateVisibilityApiAdminImagesBulkVisibilityPatchData, ThrowOnError>) => {
    return (options.client ?? client).patch<BulkUpdateVisibilityApiAdminImagesBulkVisibilityPatchResponses, BulkUpdateVisibilityApiAdminImagesBulkVisibilityPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/images/bulk/visibility',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Bulk Update Categories
 *
 * Bulk update categories for multiple images (admin only).
 *
 * Args:
 * request: Bulk category update request
 * db: Database session
 * current_user: Current authenticated user
 *
 * Returns:
 * Bulk update result
 */
export const bulkUpdateCategoriesApiAdminImagesBulkCategoriesPatch = <ThrowOnError extends boolean = false>(options: Options<BulkUpdateCategoriesApiAdminImagesBulkCategoriesPatchData, ThrowOnError>) => {
    return (options.client ?? client).patch<BulkUpdateCategoriesApiAdminImagesBulkCategoriesPatchResponses, BulkUpdateCategoriesApiAdminImagesBulkCategoriesPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/images/bulk/categories',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Bulk Delete Images
 *
 * Bulk delete multiple images (admin only).
 *
 * Args:
 * image_ids: List of image IDs to delete
 * db: Database session
 * current_user: Current authenticated user
 *
 * Returns:
 * Bulk deletion result
 */
export const bulkDeleteImagesApiAdminImagesBulkDelete = <ThrowOnError extends boolean = false>(options: Options<BulkDeleteImagesApiAdminImagesBulkDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<BulkDeleteImagesApiAdminImagesBulkDeleteResponses, BulkDeleteImagesApiAdminImagesBulkDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/images/bulk',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Cloudinary Images
 *
 * List all images directly from Cloudinary (admin only).
 *
 * This endpoint retrieves images directly from Cloudinary, which is useful for:
 * - Viewing all images in Cloudinary (even if not in database)
 * - Syncing Cloudinary with database
 * - Managing images that were uploaded outside the application
 *
 * Args:
 * folder: Optional folder path to filter by (e.g., "mariah-photography")
 * max_results: Maximum number of results (default 500, max 500)
 * next_cursor: Pagination cursor for next page
 * current_user: Current authenticated admin user
 *
 * Returns:
 * List of images from Cloudinary with pagination info
 */
export const listCloudinaryImagesApiAdminImagesCloudinaryGet = <ThrowOnError extends boolean = false>(options?: Options<ListCloudinaryImagesApiAdminImagesCloudinaryGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListCloudinaryImagesApiAdminImagesCloudinaryGetResponses, ListCloudinaryImagesApiAdminImagesCloudinaryGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/images/cloudinary',
        ...options
    });
};

/**
 * Sync Cloudinary With Database
 *
 * Sync Cloudinary images with database (admin only).
 *
 * This endpoint:
 * - Creates database records for images in Cloudinary that aren't in DB
 * - Optionally deletes DB records for images that don't exist in Cloudinary
 * - Updates metadata for existing images
 *
 * Args:
 * folder: Optional folder path to sync (e.g., "mariah-photography")
 * create_missing: If True, create DB records for Cloudinary images not in DB
 * delete_orphaned: If True, delete DB records for images not in Cloudinary
 * db: Database session
 * current_user: Current authenticated admin user
 *
 * Returns:
 * Sync result with statistics
 */
export const syncCloudinaryWithDatabaseApiAdminImagesSyncCloudinaryPost = <ThrowOnError extends boolean = false>(options?: Options<SyncCloudinaryWithDatabaseApiAdminImagesSyncCloudinaryPostData, ThrowOnError>) => {
    return (options?.client ?? client).post<SyncCloudinaryWithDatabaseApiAdminImagesSyncCloudinaryPostResponses, SyncCloudinaryWithDatabaseApiAdminImagesSyncCloudinaryPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/images/sync-cloudinary',
        ...options
    });
};

/**
 * Get Admin Statistics
 *
 * Get admin-specific statistics about images.
 *
 * Args:
 * db: Database session
 * current_user: Current authenticated user
 *
 * Returns:
 * Admin statistics
 */
export const getAdminStatisticsApiAdminImagesStatisticsGet = <ThrowOnError extends boolean = false>(options?: Options<GetAdminStatisticsApiAdminImagesStatisticsGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAdminStatisticsApiAdminImagesStatisticsGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/images/statistics',
        ...options
    });
};

/**
 * Delete Admin Image
 *
 * Delete an image by database ID or Cloudinary public_id (admin access).
 *
 * Args:
 * image_id: Database ID or Cloudinary public_id of the image
 * db: Database session
 * current_user: Current authenticated user
 *
 * Returns:
 * Success confirmation
 */
export const deleteAdminImageApiAdminImagesImageIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteAdminImageApiAdminImagesImageIdDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteAdminImageApiAdminImagesImageIdDeleteResponses, DeleteAdminImageApiAdminImagesImageIdDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/images/{image_id}',
        ...options
    });
};

/**
 * Get Admin Image
 *
 * Get a single image by ID or Cloudinary public_id (admin access).
 *
 * Args:
 * image_id: Database ID or Cloudinary public_id of the image
 * db: Database session
 * current_user: Current authenticated user
 *
 * Returns:
 * Image details (enriched with DB metadata if available)
 */
export const getAdminImageApiAdminImagesImageIdGet = <ThrowOnError extends boolean = false>(options: Options<GetAdminImageApiAdminImagesImageIdGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAdminImageApiAdminImagesImageIdGetResponses, GetAdminImageApiAdminImagesImageIdGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/images/{image_id}',
        ...options
    });
};

/**
 * Update Admin Image
 *
 * Update image metadata (admin access).
 *
 * If image doesn't exist in DB, creates a DB record from Cloudinary data.
 *
 * Args:
 * image_id: Database ID or Cloudinary public_id of the image
 * update_data: Fields to update
 * db: Database session
 * current_user: Current authenticated user
 *
 * Returns:
 * Updated image details
 */
export const updateAdminImageApiAdminImagesImageIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateAdminImageApiAdminImagesImageIdPatchData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateAdminImageApiAdminImagesImageIdPatchResponses, UpdateAdminImageApiAdminImagesImageIdPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/images/{image_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Toggle Admin Image Visibility
 *
 * Toggle image public/private visibility (admin access).
 *
 * Args:
 * image_id: Database ID of the image
 * db: Database session
 * current_user: Current authenticated user
 *
 * Returns:
 * Updated image with new visibility status
 */
export const toggleAdminImageVisibilityApiAdminImagesImageIdVisibilityPatch = <ThrowOnError extends boolean = false>(options: Options<ToggleAdminImageVisibilityApiAdminImagesImageIdVisibilityPatchData, ThrowOnError>) => {
    return (options.client ?? client).patch<ToggleAdminImageVisibilityApiAdminImagesImageIdVisibilityPatchResponses, ToggleAdminImageVisibilityApiAdminImagesImageIdVisibilityPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/images/{image_id}/visibility',
        ...options
    });
};

/**
 * Upload Admin Image
 *
 * Upload a single image to Cloudinary (admin access).
 *
 * Args:
 * file: Image file to upload
 * public_id: Unique identifier for the image
 * folder: Cloudinary folder path
 * title: Optional title for the image
 * description: Optional description for the image
 * alt_text: Optional alt text for the image
 * db: Database session
 * current_user: Current authenticated user
 *
 * Returns:
 * Upload result with URL and metadata
 */
export const uploadAdminImageApiAdminImagesUploadPost = <ThrowOnError extends boolean = false>(options: Options<UploadAdminImageApiAdminImagesUploadPostData, ThrowOnError>) => {
    return (options.client ?? client).post<UploadAdminImageApiAdminImagesUploadPostResponses, UploadAdminImageApiAdminImagesUploadPostErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/images/upload',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Upload Multiple Admin Images
 *
 * Upload multiple images to Cloudinary (admin access).
 *
 * Args:
 * files: List of image files to upload
 * public_ids: List of unique identifiers for images
 * folder: Cloudinary folder path
 * db: Database session
 * current_user: Current authenticated user
 *
 * Returns:
 * List of upload results
 */
export const uploadMultipleAdminImagesApiAdminImagesUploadMultiplePost = <ThrowOnError extends boolean = false>(options: Options<UploadMultipleAdminImagesApiAdminImagesUploadMultiplePostData, ThrowOnError>) => {
    return (options.client ?? client).post<UploadMultipleAdminImagesApiAdminImagesUploadMultiplePostResponses, UploadMultipleAdminImagesApiAdminImagesUploadMultiplePostErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/images/upload-multiple',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Get Admin Image Info
 *
 * Get information about an image (admin access).
 *
 * Args:
 * public_id: Cloudinary public ID of the image
 * db: Database session
 * current_user: Current authenticated user
 *
 * Returns:
 * Image information
 */
export const getAdminImageInfoApiAdminImagesPublicIdInfoGet = <ThrowOnError extends boolean = false>(options: Options<GetAdminImageInfoApiAdminImagesPublicIdInfoGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAdminImageInfoApiAdminImagesPublicIdInfoGetResponses, GetAdminImageInfoApiAdminImagesPublicIdInfoGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/images/{public_id}/info',
        ...options
    });
};

/**
 * List Contact Submissions Admin
 *
 * List all contact submissions ordered by newest first (admin only).
 *
 * Args:
 * db: Database session
 * current_user: Current authenticated admin user
 *
 * Returns:
 * List of contact submissions ordered by created_at descending
 */
export const listContactSubmissionsAdminApiAdminContactSubmissionsGet = <ThrowOnError extends boolean = false>(options?: Options<ListContactSubmissionsAdminApiAdminContactSubmissionsGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListContactSubmissionsAdminApiAdminContactSubmissionsGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/contact-submissions',
        ...options
    });
};

/**
 * Mark Contact Submission Viewed
 *
 * Mark a contact submission as viewed (admin only).
 *
 * Args:
 * submission_id: ID of the submission to mark as viewed
 * db: Database session
 * current_user: Current authenticated admin user
 *
 * Returns:
 * Success message
 */
export const markContactSubmissionViewedApiAdminContactSubmissionsSubmissionIdViewedPatch = <ThrowOnError extends boolean = false>(options: Options<MarkContactSubmissionViewedApiAdminContactSubmissionsSubmissionIdViewedPatchData, ThrowOnError>) => {
    return (options.client ?? client).patch<MarkContactSubmissionViewedApiAdminContactSubmissionsSubmissionIdViewedPatchResponses, MarkContactSubmissionViewedApiAdminContactSubmissionsSubmissionIdViewedPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/contact-submissions/{submission_id}/viewed',
        ...options
    });
};

/**
 * Mark Contact Submission Unviewed
 *
 * Mark a contact submission as unviewed (admin only).
 *
 * Args:
 * submission_id: ID of the submission to mark as unviewed
 * db: Database session
 * current_user: Current authenticated admin user
 *
 * Returns:
 * Success message
 */
export const markContactSubmissionUnviewedApiAdminContactSubmissionsSubmissionIdUnviewedPatch = <ThrowOnError extends boolean = false>(options: Options<MarkContactSubmissionUnviewedApiAdminContactSubmissionsSubmissionIdUnviewedPatchData, ThrowOnError>) => {
    return (options.client ?? client).patch<MarkContactSubmissionUnviewedApiAdminContactSubmissionsSubmissionIdUnviewedPatchResponses, MarkContactSubmissionUnviewedApiAdminContactSubmissionsSubmissionIdUnviewedPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/contact-submissions/{submission_id}/unviewed',
        ...options
    });
};

/**
 * Get Unviewed Submissions Count
 *
 * Get the count of unviewed contact submissions (admin only).
 *
 * Args:
 * db: Database session
 * current_user: Current authenticated admin user
 *
 * Returns:
 * Count of unviewed submissions
 */
export const getUnviewedSubmissionsCountApiAdminContactSubmissionsUnviewedCountGet = <ThrowOnError extends boolean = false>(options?: Options<GetUnviewedSubmissionsCountApiAdminContactSubmissionsUnviewedCountGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUnviewedSubmissionsCountApiAdminContactSubmissionsUnviewedCountGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/contact-submissions/unviewed-count',
        ...options
    });
};

/**
 * Get Public Gallery
 *
 * Get public images for the portfolio gallery.
 *
 * This endpoint returns only public images (is_public=True) and is accessible
 * without authentication. It supports filtering, searching, and sorting.
 *
 * Args:
 * page: Page number (1-indexed)
 * page_size: Items per page (max 100)
 * category_id: Filter by category ID
 * subcategory_id: Filter by subcategory ID
 * tag: Filter by tag name
 * search: Search in title, description, alt_text
 * sort_by: Sort field (upload_date, title, taken_date)
 * sort_order: Sort direction (asc, desc)
 * db: Database session
 *
 * Returns:
 * Paginated list of public images
 */
export const getPublicGalleryApiPublicGalleryGet = <ThrowOnError extends boolean = false>(options?: Options<GetPublicGalleryApiPublicGalleryGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPublicGalleryApiPublicGalleryGetResponses, GetPublicGalleryApiPublicGalleryGetErrors, ThrowOnError>({
        url: '/api/public/gallery',
        ...options
    });
};

/**
 * Get Featured Public Images
 *
 * Get featured public images for the homepage.
 *
 * Args:
 * limit: Maximum number of featured images to return (max 20)
 * db: Database session
 *
 * Returns:
 * List of featured public images
 */
export const getFeaturedPublicImagesApiPublicGalleryFeaturedGet = <ThrowOnError extends boolean = false>(options?: Options<GetFeaturedPublicImagesApiPublicGalleryFeaturedGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFeaturedPublicImagesApiPublicGalleryFeaturedGetResponses, GetFeaturedPublicImagesApiPublicGalleryFeaturedGetErrors, ThrowOnError>({
        url: '/api/public/gallery/featured',
        ...options
    });
};

/**
 * Get Public Categories
 *
 * Get all categories that have public images.
 *
 * Args:
 * db: Database session
 *
 * Returns:
 * List of categories with public image counts
 */
export const getPublicCategoriesApiPublicGalleryCategoriesGet = <ThrowOnError extends boolean = false>(options?: Options<GetPublicCategoriesApiPublicGalleryCategoriesGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPublicCategoriesApiPublicGalleryCategoriesGetResponses, unknown, ThrowOnError>({
        url: '/api/public/gallery/categories',
        ...options
    });
};

/**
 * Get Public Tags
 *
 * Get all tags that are used on public images.
 *
 * Args:
 * db: Database session
 *
 * Returns:
 * List of tags with public image counts
 */
export const getPublicTagsApiPublicGalleryTagsGet = <ThrowOnError extends boolean = false>(options?: Options<GetPublicTagsApiPublicGalleryTagsGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPublicTagsApiPublicGalleryTagsGetResponses, unknown, ThrowOnError>({
        url: '/api/public/gallery/tags',
        ...options
    });
};

/**
 * Record Image View
 *
 * Record a view for an image.
 *
 * This endpoint is called when a user views an image to track analytics.
 * It's accessible without authentication for public images.
 *
 * Args:
 * image_id: Image ID to record view for
 * request: FastAPI request object (for IP, user agent, referrer)
 * db: Database session
 *
 * Returns:
 * Success confirmation
 */
export const recordImageViewApiPublicImagesImageIdViewPost = <ThrowOnError extends boolean = false>(options: Options<RecordImageViewApiPublicImagesImageIdViewPostData, ThrowOnError>) => {
    return (options.client ?? client).post<RecordImageViewApiPublicImagesImageIdViewPostResponses, RecordImageViewApiPublicImagesImageIdViewPostErrors, ThrowOnError>({
        url: '/api/public/images/{image_id}/view',
        ...options
    });
};

/**
 * Get Public Albums
 *
 * Get public albums for the portfolio gallery.
 *
 * This endpoint returns only public albums (is_public=True) and is accessible
 * without authentication. It supports filtering, searching, and pagination.
 *
 * Args:
 * page: Page number (1-indexed)
 * page_size: Items per page (max 100)
 * search: Search in title and description
 * db: Database session
 *
 * Returns:
 * Paginated list of public albums
 */
export const getPublicAlbumsApiPublicAlbumsGet = <ThrowOnError extends boolean = false>(options?: Options<GetPublicAlbumsApiPublicAlbumsGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPublicAlbumsApiPublicAlbumsGetResponses, GetPublicAlbumsApiPublicAlbumsGetErrors, ThrowOnError>({
        url: '/api/public/albums',
        ...options
    });
};

/**
 * Get Featured Public Albums
 *
 * Get featured public albums for the homepage.
 *
 * Args:
 * limit: Maximum number of featured albums to return (max 20)
 * db: Database session
 *
 * Returns:
 * List of featured public albums
 */
export const getFeaturedPublicAlbumsApiPublicAlbumsFeaturedGet = <ThrowOnError extends boolean = false>(options?: Options<GetFeaturedPublicAlbumsApiPublicAlbumsFeaturedGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFeaturedPublicAlbumsApiPublicAlbumsFeaturedGetResponses, GetFeaturedPublicAlbumsApiPublicAlbumsFeaturedGetErrors, ThrowOnError>({
        url: '/api/public/albums/featured',
        ...options
    });
};

/**
 * Get Public Album
 *
 * Get a public album by ID.
 *
 * Args:
 * album_id: Album ID
 * db: Database session
 *
 * Returns:
 * Album (only if it's public)
 *
 * Raises:
 * HTTPException: If album not found or not public
 */
export const getPublicAlbumApiPublicAlbumsAlbumIdGet = <ThrowOnError extends boolean = false>(options: Options<GetPublicAlbumApiPublicAlbumsAlbumIdGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPublicAlbumApiPublicAlbumsAlbumIdGetResponses, GetPublicAlbumApiPublicAlbumsAlbumIdGetErrors, ThrowOnError>({
        url: '/api/public/albums/{album_id}',
        ...options
    });
};

/**
 * Get Public Album Images
 *
 * Get images for a public album.
 *
 * Args:
 * album_id: Album ID
 * db: Database session
 *
 * Returns:
 * List of images in the album (only if album is public)
 *
 * Raises:
 * HTTPException: If album not found or not public
 */
export const getPublicAlbumImagesApiPublicAlbumsAlbumIdImagesGet = <ThrowOnError extends boolean = false>(options: Options<GetPublicAlbumImagesApiPublicAlbumsAlbumIdImagesGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPublicAlbumImagesApiPublicAlbumsAlbumIdImagesGetResponses, GetPublicAlbumImagesApiPublicAlbumsAlbumIdImagesGetErrors, ThrowOnError>({
        url: '/api/public/albums/{album_id}/images',
        ...options
    });
};

/**
 * Record Album View
 *
 * Record a view for an album/gallery.
 *
 * This endpoint is called when a user views a gallery to track analytics.
 * It's accessible without authentication for public albums.
 *
 * Args:
 * album_id: Album ID to record view for
 * request: FastAPI request object (for IP, user agent, referrer)
 * db: Database session
 *
 * Returns:
 * Success confirmation
 */
export const recordAlbumViewApiPublicAlbumsAlbumIdViewPost = <ThrowOnError extends boolean = false>(options: Options<RecordAlbumViewApiPublicAlbumsAlbumIdViewPostData, ThrowOnError>) => {
    return (options.client ?? client).post<RecordAlbumViewApiPublicAlbumsAlbumIdViewPostResponses, RecordAlbumViewApiPublicAlbumsAlbumIdViewPostErrors, ThrowOnError>({
        url: '/api/public/albums/{album_id}/view',
        ...options
    });
};

/**
 * Get Testimonials
 *
 * Get all published testimonials.
 */
export const getTestimonialsApiPublicTestimonialsGet = <ThrowOnError extends boolean = false>(options?: Options<GetTestimonialsApiPublicTestimonialsGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetTestimonialsApiPublicTestimonialsGetResponses, unknown, ThrowOnError>({
        url: '/api/public/testimonials',
        ...options
    });
};

/**
 * Submit Contact Form
 *
 * Submit a contact form.
 *
 * This endpoint accepts contact form submissions and sends an email notification
 * to the configured contact email address.
 */
export const submitContactFormApiPublicContactPost = <ThrowOnError extends boolean = false>(options: Options<SubmitContactFormApiPublicContactPostData, ThrowOnError>) => {
    return (options.client ?? client).post<SubmitContactFormApiPublicContactPostResponses, SubmitContactFormApiPublicContactPostErrors, ThrowOnError>({
        url: '/api/public/contact',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Categories
 *
 * List all categories (public endpoint).
 *
 * Args:
 * include_inactive: Whether to include inactive categories
 * db: Database session
 *
 * Returns:
 * List of categories
 */
export const listCategoriesApiCategoriesGet = <ThrowOnError extends boolean = false>(options?: Options<ListCategoriesApiCategoriesGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListCategoriesApiCategoriesGetResponses, ListCategoriesApiCategoriesGetErrors, ThrowOnError>({
        url: '/api/categories',
        ...options
    });
};

/**
 * Create Category
 *
 * Create a new category (admin only).
 *
 * Args:
 * category_data: Category data
 * db: Database session
 * current_user: Current authenticated admin user
 *
 * Returns:
 * Created category
 */
export const createCategoryApiCategoriesPost = <ThrowOnError extends boolean = false>(options: Options<CreateCategoryApiCategoriesPostData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateCategoryApiCategoriesPostResponses, CreateCategoryApiCategoriesPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/categories',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Subcategories
 *
 * List subcategories (public endpoint).
 *
 * Args:
 * category_id: Optional category ID to filter by
 * include_inactive: Whether to include inactive subcategories
 * db: Database session
 *
 * Returns:
 * List of subcategories
 */
export const listSubcategoriesApiCategoriesSubcategoriesGet = <ThrowOnError extends boolean = false>(options?: Options<ListSubcategoriesApiCategoriesSubcategoriesGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListSubcategoriesApiCategoriesSubcategoriesGetResponses, ListSubcategoriesApiCategoriesSubcategoriesGetErrors, ThrowOnError>({
        url: '/api/categories/subcategories',
        ...options
    });
};

/**
 * Create Subcategory
 *
 * Create a new subcategory (admin only).
 *
 * Args:
 * subcategory_data: Subcategory data
 * db: Database session
 * current_user: Current authenticated admin user
 *
 * Returns:
 * Created subcategory
 */
export const createSubcategoryApiCategoriesSubcategoriesPost = <ThrowOnError extends boolean = false>(options: Options<CreateSubcategoryApiCategoriesSubcategoriesPostData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateSubcategoryApiCategoriesSubcategoriesPostResponses, CreateSubcategoryApiCategoriesSubcategoriesPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/categories/subcategories',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Subcategory
 *
 * Delete a subcategory (admin only).
 *
 * Args:
 * subcategory_id: Subcategory ID
 * db: Database session
 * current_user: Current authenticated admin user
 */
export const deleteSubcategoryApiCategoriesSubcategoriesSubcategoryIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteSubcategoryApiCategoriesSubcategoriesSubcategoryIdDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteSubcategoryApiCategoriesSubcategoriesSubcategoryIdDeleteResponses, DeleteSubcategoryApiCategoriesSubcategoriesSubcategoryIdDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/categories/subcategories/{subcategory_id}',
        ...options
    });
};

/**
 * Get Subcategory
 *
 * Get a single subcategory by ID (public endpoint).
 *
 * Args:
 * subcategory_id: Subcategory ID
 * db: Database session
 *
 * Returns:
 * Subcategory
 */
export const getSubcategoryApiCategoriesSubcategoriesSubcategoryIdGet = <ThrowOnError extends boolean = false>(options: Options<GetSubcategoryApiCategoriesSubcategoriesSubcategoryIdGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSubcategoryApiCategoriesSubcategoriesSubcategoryIdGetResponses, GetSubcategoryApiCategoriesSubcategoriesSubcategoryIdGetErrors, ThrowOnError>({
        url: '/api/categories/subcategories/{subcategory_id}',
        ...options
    });
};

/**
 * Update Subcategory
 *
 * Update a subcategory (admin only).
 *
 * Args:
 * subcategory_id: Subcategory ID
 * update_data: Fields to update
 * db: Database session
 * current_user: Current authenticated admin user
 *
 * Returns:
 * Updated subcategory
 */
export const updateSubcategoryApiCategoriesSubcategoriesSubcategoryIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateSubcategoryApiCategoriesSubcategoriesSubcategoryIdPatchData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateSubcategoryApiCategoriesSubcategoriesSubcategoryIdPatchResponses, UpdateSubcategoryApiCategoriesSubcategoriesSubcategoryIdPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/categories/subcategories/{subcategory_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Category
 *
 * Delete a category (admin only).
 *
 * Args:
 * category_id: Category ID
 * db: Database session
 * current_user: Current authenticated admin user
 */
export const deleteCategoryApiCategoriesCategoryIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteCategoryApiCategoriesCategoryIdDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteCategoryApiCategoriesCategoryIdDeleteResponses, DeleteCategoryApiCategoriesCategoryIdDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/categories/{category_id}',
        ...options
    });
};

/**
 * Get Category
 *
 * Get a single category by ID (public endpoint).
 *
 * Args:
 * category_id: Category ID
 * db: Database session
 *
 * Returns:
 * Category
 */
export const getCategoryApiCategoriesCategoryIdGet = <ThrowOnError extends boolean = false>(options: Options<GetCategoryApiCategoriesCategoryIdGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetCategoryApiCategoriesCategoryIdGetResponses, GetCategoryApiCategoriesCategoryIdGetErrors, ThrowOnError>({
        url: '/api/categories/{category_id}',
        ...options
    });
};

/**
 * Update Category
 *
 * Update a category (admin only).
 *
 * Args:
 * category_id: Category ID
 * update_data: Fields to update
 * db: Database session
 * current_user: Current authenticated admin user
 *
 * Returns:
 * Updated category
 */
export const updateCategoryApiCategoriesCategoryIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateCategoryApiCategoriesCategoryIdPatchData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateCategoryApiCategoriesCategoryIdPatchResponses, UpdateCategoryApiCategoriesCategoryIdPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/categories/{category_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Albums
 *
 * List all albums with pagination and filtering.
 *
 * Args:
 * page: Page number (1-indexed)
 * page_size: Items per page (max 100)
 * is_public: Filter by public status
 * is_featured: Filter by featured status
 * search: Search in title and description
 * db: Database session
 * current_user: Current authenticated admin user
 *
 * Returns:
 * Paginated list of albums
 */
export const listAlbumsApiAdminAlbumsGet = <ThrowOnError extends boolean = false>(options?: Options<ListAlbumsApiAdminAlbumsGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListAlbumsApiAdminAlbumsGetResponses, ListAlbumsApiAdminAlbumsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/albums',
        ...options
    });
};

/**
 * Create Album
 *
 * Create a new album/gallery.
 *
 * Args:
 * album_data: Album data to create
 * db: Database session
 * current_user: Current authenticated admin user
 *
 * Returns:
 * Created album
 *
 * Raises:
 * HTTPException: If creation fails
 */
export const createAlbumApiAdminAlbumsPost = <ThrowOnError extends boolean = false>(options: Options<CreateAlbumApiAdminAlbumsPostData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateAlbumApiAdminAlbumsPostResponses, CreateAlbumApiAdminAlbumsPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/albums',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Album
 *
 * Delete an album.
 *
 * Args:
 * album_id: Album ID
 * db: Database session
 * current_user: Current authenticated admin user
 *
 * Raises:
 * HTTPException: If deletion fails
 */
export const deleteAlbumApiAdminAlbumsAlbumIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteAlbumApiAdminAlbumsAlbumIdDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteAlbumApiAdminAlbumsAlbumIdDeleteResponses, DeleteAlbumApiAdminAlbumsAlbumIdDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/albums/{album_id}',
        ...options
    });
};

/**
 * Get Album
 *
 * Get an album by ID.
 *
 * Args:
 * album_id: Album ID
 * db: Database session
 * current_user: Current authenticated admin user
 *
 * Returns:
 * Album
 *
 * Raises:
 * HTTPException: If album not found
 */
export const getAlbumApiAdminAlbumsAlbumIdGet = <ThrowOnError extends boolean = false>(options: Options<GetAlbumApiAdminAlbumsAlbumIdGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAlbumApiAdminAlbumsAlbumIdGetResponses, GetAlbumApiAdminAlbumsAlbumIdGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/albums/{album_id}',
        ...options
    });
};

/**
 * Update Album
 *
 * Update an album.
 *
 * Args:
 * album_id: Album ID
 * album_data: Album data to update
 * db: Database session
 * current_user: Current authenticated admin user
 *
 * Returns:
 * Updated album
 *
 * Raises:
 * HTTPException: If update fails
 */
export const updateAlbumApiAdminAlbumsAlbumIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateAlbumApiAdminAlbumsAlbumIdPatchData, ThrowOnError>) => {
    return (options.client ?? client).patch<UpdateAlbumApiAdminAlbumsAlbumIdPatchResponses, UpdateAlbumApiAdminAlbumsAlbumIdPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/albums/{album_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Album Images
 *
 * Get images for an album (admin endpoint - works for both public and private albums).
 *
 * Args:
 * album_id: Album ID
 * db: Database session
 * current_user: Current authenticated admin user
 *
 * Returns:
 * List of images in the album
 *
 * Raises:
 * HTTPException: If album not found
 */
export const getAlbumImagesApiAdminAlbumsAlbumIdImagesGet = <ThrowOnError extends boolean = false>(options: Options<GetAlbumImagesApiAdminAlbumsAlbumIdImagesGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAlbumImagesApiAdminAlbumsAlbumIdImagesGetResponses, GetAlbumImagesApiAdminAlbumsAlbumIdImagesGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/albums/{album_id}/images',
        ...options
    });
};

/**
 * Get Public Settings
 *
 * Get all public site settings.
 * This endpoint is accessible without authentication.
 */
export const getPublicSettingsApiSiteSettingsPublicGet = <ThrowOnError extends boolean = false>(options?: Options<GetPublicSettingsApiSiteSettingsPublicGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetPublicSettingsApiSiteSettingsPublicGetResponses, unknown, ThrowOnError>({
        url: '/api/site-settings/public',
        ...options
    });
};

/**
 * List Settings
 *
 * List all site settings.
 * Requires admin authentication.
 */
export const listSettingsApiSiteSettingsGet = <ThrowOnError extends boolean = false>(options?: Options<ListSettingsApiSiteSettingsGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListSettingsApiSiteSettingsGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/site-settings',
        ...options
    });
};

/**
 * Create Setting
 *
 * Create a new site setting.
 * Requires admin authentication.
 */
export const createSettingApiSiteSettingsPost = <ThrowOnError extends boolean = false>(options: Options<CreateSettingApiSiteSettingsPostData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateSettingApiSiteSettingsPostResponses, CreateSettingApiSiteSettingsPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/site-settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Setting
 *
 * Delete a site setting.
 * Requires admin authentication.
 */
export const deleteSettingApiSiteSettingsKeyDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteSettingApiSiteSettingsKeyDeleteData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteSettingApiSiteSettingsKeyDeleteResponses, DeleteSettingApiSiteSettingsKeyDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/site-settings/{key}',
        ...options
    });
};

/**
 * Get Setting
 *
 * Get a specific site setting by key.
 * Requires admin authentication.
 */
export const getSettingApiSiteSettingsKeyGet = <ThrowOnError extends boolean = false>(options: Options<GetSettingApiSiteSettingsKeyGetData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSettingApiSiteSettingsKeyGetResponses, GetSettingApiSiteSettingsKeyGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/site-settings/{key}',
        ...options
    });
};

/**
 * Update Setting
 *
 * Update a site setting.
 * Requires admin authentication.
 */
export const updateSettingApiSiteSettingsKeyPut = <ThrowOnError extends boolean = false>(options: Options<UpdateSettingApiSiteSettingsKeyPutData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateSettingApiSiteSettingsKeyPutResponses, UpdateSettingApiSiteSettingsKeyPutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/site-settings/{key}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Image Sitemap
 *
 * Generate and return image sitemap.xml.
 *
 * Includes all images from public galleries/albums.
 *
 * Returns:
 * XML image sitemap response
 */
export const getImageSitemapSitemapImagesXmlGet = <ThrowOnError extends boolean = false>(options?: Options<GetImageSitemapSitemapImagesXmlGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetImageSitemapSitemapImagesXmlGetResponses, unknown, ThrowOnError>({
        url: '/sitemap-images.xml',
        ...options
    });
};

/**
 * Get Sitemap
 *
 * Generate and return dynamic sitemap.xml.
 *
 * Includes:
 * - Static pages (home, galleries, about, contact)
 * - All public galleries/albums
 *
 * Returns:
 * XML sitemap response
 */
export const getSitemapSitemapXmlGet = <ThrowOnError extends boolean = false>(options?: Options<GetSitemapSitemapXmlGetData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSitemapSitemapXmlGetResponses, unknown, ThrowOnError>({
        url: '/sitemap.xml',
        ...options
    });
};
